import { useQuery } from '@tanstack/react-query';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetBulkReplaceEligibleAssemblyId = (
  filters: string[] = [],
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: queryKeys.bulkReplaceEligibleAssemblyIds.all(filters),
    queryFn: () => fetchBulkReplaceEligibleAssemblyIds(filters),
    staleTime: Infinity,
    enabled,
  });
};

const fetchBulkReplaceEligibleAssemblyIds = async (filters: string[] = []) => {
  const response = await requestCCApi({
    url: `/bulkReplaceEligibleAssemblyId${generateQuery([], filters)}`,
  });

  return response.data as { assembly_id: number[] };
};
